import { PublicPage } from '../base.js';
import { AppConfig } from '../../config.js';
import { setupPasswordToggles } from './ui.js';

export class Login extends PublicPage {
  static timl = `
    section.auth-page[aria-labelledby="login-title"]
      form.stacked-form.auth-form[action="${AppConfig.authServiceApiBaseUrl}/en/1/login" handler="Login.loginHandler" onSuccessRedirect="/" method="POST"]
        header.auth-header
          h1#login-title Login
          p Welcome back to Instant Suite.
        .auth-fields
          label.auth-field
            span Email address
            input[name="email" type="email" autocomplete="email" placeholder="you@example.com" required="true"]
          label.auth-field.auth-password-field
            span Password
            input[name="password" type="password" autocomplete="current-password" placeholder="Enter your password" required="true"]
            button.auth-password-toggle[type="button" aria-label="Show password" aria-pressed="false"]
              span.auth-eye[aria-hidden="true"]
        .auth-submit-row
          button.auth-primary[type="submit"] Log in
        .auth-support-link
          a[href="/forgot-password"] Forgot your password?
        .auth-divider[aria-hidden="true"]
          span or
        p.auth-switch
          span Don't have an account?
          a[href="/register"] Register
  `;

  static javascript() {
    setupPasswordToggles();
  }

  static async loginHandler(form, data) {
    if (!data.success) return true;

    Auth.setAuthenticatedSession(data);
    try {
      await Auth.ensureSuiteBootstrap();
      return true;
    } catch (error) {
      Form.showSuiteBootstrapError(form, error, () => {
        TIML.handleRedirect(`/${Translations.langCode || 'en'}`);
      });
      return false;
    }
  }
}

globalThis.Login = Login;
